<template>
  <div id="app">
    <Header @name="updateTitle($event)"></Header>
    <router-view></router-view>
    <Footer id="call"></Footer>
  </div>
</template>

<script>
import Footer from "@/components/footer.vue";
  import Header from "@/components/header.vue";
  export default {
    components:{
      Footer,
      Header
    },
    methods:{
      updateTitle($event) {
        console.log($event);
        const returnEle = document.querySelector(`#${$event}`);
        console.log(returnEle)
        if (!!returnEle) {
          returnEle.scrollIntoView(true);
        }
      },
    }
  }
</script>

<style>
  body {
  }
 
</style>